var map = {
	"./1.svg": "08c9",
	"./10.svg": "0025",
	"./10_klein.svg": "6518",
	"./10k.svg": "6394",
	"./1_klein.svg": "91a7",
	"./1k.svg": "24d1",
	"./2.svg": "db2c",
	"./2_klein.svg": "4753",
	"./2k.svg": "c47b",
	"./3.svg": "ebed",
	"./3_klein.svg": "265c",
	"./3k.svg": "b86b",
	"./4.svg": "6e9c",
	"./4_klein.svg": "a449",
	"./4k.svg": "d6f6",
	"./5.svg": "14f3",
	"./5_klein.svg": "63ac",
	"./5k.svg": "8deb",
	"./6.svg": "a04b",
	"./6_klein.svg": "6aa7",
	"./6k.svg": "bb96",
	"./7.svg": "b1a6",
	"./7_klein.svg": "45ee",
	"./7k.svg": "1566",
	"./8.svg": "0058",
	"./8_klein.svg": "02c5",
	"./8k.svg": "e3ae",
	"./9.svg": "8630",
	"./9_klein.svg": "e0e7",
	"./9k.svg": "948f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e692";